<template>
    <div id="UserPlacesList">
        <b-container>
            <h5 class="text-center">
                {{ $t('AUTHOR') }} : {{ userName }}. {{ $t('PLACES') }}.
                <span v-if="published && (author || admin)">{{$t('PUBLISHED')}}</span>
                <span v-else-if="!published && (author || admin)">{{$t('UNPUBLISHED')}}</span>
            </h5>
                <b-table
                    ref="itemList"
                    selectable
                    hover
                    :items="items"
                    :fields="fields"
                    :key="myKey"
                    striped
                    head-row-variant="info"
                    @row-selected="onRowSelected"
                >
                </b-table>
                <br><br>

            <div class="modalConf">
                <b-modal id="modalConf">
                    <div class="d-block text-center">
                        <h4>{{this.$t('SURE')}}</h4>
                    </div>
                    <template v-slot:modal-footer="{ cancel }">
                        <b-button variant="success" @click="cancel()">{{$t('CANCEL')}}</b-button>
                        <b-button variant="danger" @click="canAct()">{{$t('GO_ON')}}</b-button>
                    </template>
                </b-modal>
            </div>

        </b-container>

        <b-container fluid class = "footer text-center">

            <center>
                <b-form-radio-group id="radio-group-2" v-model="selected" name="radio-sub-component">
                    <a v-b-popover.hover.top="this.$t('SHOW')" title="" class="shBt" v-if="author || admin">
                        <b-form-radio value="Place"><font-awesome-icon icon="eye" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('REF_GEO')" title="" v-if="admin">
                        <b-form-radio value="RefAdd"><font-awesome-icon icon="book" size="lg"/></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('EDIT')" title="" v-if="!published && author">
                        <b-form-radio value="ManagePlaceMarker"><font-awesome-icon icon="edit" size="lg"/></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('PUBLISH')" title="" v-if="!published && (author || admin)">
                        <b-form-radio value="publishPlace"><font-awesome-icon icon="users" size="lg"/></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('UNPUBLISH')" title="" v-if="published && (author || admin)">
                        <b-form-radio value="unPublishPlace"><font-awesome-icon icon="users-slash" size="lg"/></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('DELETE')" title="" v-if="author || admin" class="shBt">
                        <b-form-radio value="deletePlace"><font-awesome-icon icon="trash-alt" size="lg" :style="{ color: 'white' }"/></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('BLOCK')" title="" v-if="admin">
                        <b-form-radio value="blockPlace"><font-awesome-icon icon="lock" size="lg"/></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('UNBLOCK')" title="" v-if="admin">
                        <b-form-radio value="unBlockPlace"><font-awesome-icon icon="lock-open" size="lg"/></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('HELP')" title="" v-if="author || admin" class="shBt">
                        <b-button class="m-1" @click.stop.prevent="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
                    </a>
                </b-form-radio-group>
            </center>

        </b-container>

        <Publish
                v-on:reloadList="reloadList"
                v-bind:userName="userName"
                v-bind:itemName="itemName"
                itemType="places"
                :key="myKey"
                v-if="action==='publishPlace'"

        />

        <Block
                v-on:reloadList="reloadList"
                v-bind:userName="userName"
                v-bind:itemName="itemName"
                itemType="places"
                :key="myKey"
                v-if="action==='blockPlace'"
        />

        <Help
                v-on:closeHelp="showHelp=false"
                v-bind:helpName="helpName"
                v-if="showHelp"
        />

    </div>

</template>

<script>
import { BContainer, BModal, BTable, BButton, BFormRadio, BFormRadioGroup } from 'bootstrap-vue';
import Publish from "./Publish.vue";
import Block from "./Block.vue";
import Help from "./Help.vue";

export default {
  name: 'UserPlacesList',
  components: {
    Publish, Block, Help,
    BContainer, BModal, BTable, BButton, BFormRadio, BFormRadioGroup
  },
  data: function() {
    return {
        fields: [
          {
            key: 'placeName',
            label: this.$t('PLACE_NAME'),
            sortable: true
          },
          {
            key: 'tripName',
            label: this.$t('TRIP_NAME'),
            sortable: true
          },
          {
            key: 'pubDate',
            label: this.$t('DATE_PUB'),
            sortable: true
          }
        ],
        myKey: 0,
        items: [{}],
        tblName: '',
        userName: '',
        curUserName: '',
        placeName: '',
        intLoc: this.$i18n.locale,
        item: {},
        selected: 'Place',
        curLang: '',
        status: 'unchecked',
        published: true,
        blocked: false,
        free: true,
        action: '',
        itemName: '',
        helpName: 'HelpUserPlacesList',
        showHelp: false
    }
  },
  beforeMount() {
    this.curUserName = this.$store.state.curUserName;
    this.userName = this.$rmEncHyp(this.$route.params.userName);
    if(this.curUserName && (this.curUserName === this.userName || this.curUserName === 'admin') ) {
        this.published = this.$route.query.published === 'false' ? false: true;
        this.blocked = this.$route.query.blocked === 'true' ? true: false;
        this.free = this.$route.query.free === 'false' ? '': 'true';
    }
    else {
        this.published = true;
        this.blocked = false;
        this.free = true;
    }
    this.getList();
  },
  methods: {
    reloadList() {
        this.selected='Place';
        this.action='';
        this.getList();
        this.myKey++;
    },
    async getList() {
        //console.log(this.intLoc, this.free, this.published, this.blocked);
        try {
            const response = await this.$http.get('/getUserPlaces', {
                params: {
                    userName: this.userName,
                    published: this.published,
                    blocked: this.blocked,
                    listLoc: this.intLoc,
                    free: this.free
                }
            });
            this.items = response.data;
            if(this.items.length == 0) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                this.$router.go(-1);
            }
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async onRowSelected(items) {
        this.item = items[0];
        this.placeName = this.item.placeName;
        if(this.selected==='Place') {
            this.$router.push({
                path: '/Place/'+this.$addEncHyp(this.placeName)+'/'+this.$addEncHyp(this.userName)
            })
        }
        else if(this.selected==='ManagePlaceMarker') {
            this.$router.push({
               path: '/Map/ManagePlaceMarker/'+this.$addEncHyp(this.placeName)+'/'+this.$addEncHyp(this.userName)
            })
        }
        else if(this.selected==='RefAdd') {
            this.$router.push({
               path: '/ManageRef',
               query: {
                    userName: this.$addEncHyp(this.userName),
                    itemName: this.$addEncHyp(this.placeName),
                    itemType: 'p'
               }
            })
        }
        else if(this.selected==='publishPlace' || this.selected==='blockPlace') {
            this.itemName = this.placeName;
            this.action = this.selected;
        }
        else this.$bvModal.show('modalConf');
    },
    async canAct() {
        this.$bvModal.hide('modalConf');
        try {
            await this.$http.get('/'+this.selected, {
                params: {
                    userName: this.userName,
                    placeName: this.placeName
                }
            });
            this.$showMsg(this.$t('DONE'));
            this.reloadList();
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.reloadList();
    }
  },
  computed: {
    rows() {
        return this.listLength;
    },
    author() { return this.userName === this.curUserName },
    admin() { return this.curUserName === 'admin' }
  }
}

</script>

<style>
/*
    #tblName{
        color: blue;
    }
*/
</style>
